import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import styled from "styled-components";
import { FlexRow, FlexColumn } from "../../../styles/styled-components-utils";
import Admin from "./Admin";
import ExploreButton from "./ExploreButton";
import LoginButton from "./LoginButton";
import LogoutButton from "./LogoutButton";
import SignUpButton from "./SignUpButton";
import SimpleButton from "./SimpleButton";

const NavActions = styled(FlexRow)`
  justify-content: flex-end;
  align-items: center;
  flex-grow: 1;
  position: relative; /* Create positioning context for dropdown */

  /* On desktop, escape parent stacking context (container1: 101) so the
     dropdown sits above any sticky page chrome. */
  @media only screen and (min-width: 600px) {
    z-index: 1000;
  }
`;

const MenuIcon = styled.i`
  color: white;
  padding: 3px;
  transition: color var(--transition-base);

  &:hover {
    color: var(--color-primary-light);
  }
`;

const DropdownMenu = styled(FlexColumn)`
  z-index: var(--z-modal);
  background-color: var(--color-primary);
  border-top: 1px solid var(--color-primary-light);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
  position: absolute;
  right: 0;
  align-items: flex-end;
  justify-content: center;
  transition: opacity var(--transition-base), transform var(--transition-base);
  ${(props) => {
    if (!props.openMenu) {
      return `
        display: none;
        `;
    }
  }}

  /* On desktop, escape parent stacking context (container1: 101) so the
     dropdown sits above any sticky page chrome. */
  @media only screen and (min-width: 600px) {
    z-index: 1000;
    isolation: isolate;
  }
`;

const FlexDiv = styled(FlexRow)``;
const Actions = ({ token }) => {
  const [openMenu, toggleMenu] = useState(false);
  const { pathname } = useLocation();
  return (
    <NavActions>
      <div
        tabIndex={0}
        role="button"
        aria-label="Open navigation menu"
        aria-expanded={openMenu}
        onBlur={(e) => {
          e.preventDefault();
          if (!e.target.contains(e.relatedTarget)) {
            toggleMenu(false);
          }
        }}
        onClick={() => toggleMenu(!openMenu)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggleMenu(!openMenu);
          }
        }}
      >
        <MenuIcon className="fas fa-bars fa-3x"></MenuIcon>
        <DropdownMenu openMenu={openMenu}>
          <FlexDiv>
            <ExploreButton />
          </FlexDiv>
          {!token && (
            <FlexDiv>
              <SignUpButton path={pathname} />
            </FlexDiv>
          )}
          {!token && (
            <FlexDiv>
              <LoginButton path={pathname} />
            </FlexDiv>
          )}
          {token && (
            <FlexDiv>
              <Admin />
            </FlexDiv>
          )}
          {
            <FlexDiv>
              <SimpleButton name="events" label="Events" />
            </FlexDiv>
          }
          {
            <FlexDiv>
              <SimpleButton name="consulting" />
            </FlexDiv>
          }
          {
            <FlexDiv>
              <SimpleButton name="organizing-a-festival" label="Organizing a Festival" />
            </FlexDiv>
          }
          {token && (
            <FlexDiv>
              <LogoutButton />
            </FlexDiv>
          )}
        </DropdownMenu>
      </div>
    </NavActions>
  );
};

const mapStateToProps = (state) => ({
  token: state.auth.token,
});
export default connect(mapStateToProps, {})(Actions);
